import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface PageTitleProps {
  /** Page heading — rendered with the theme's `h1` page-title variant. */
  title: string;
  /** Optional one-line description under the title (tertiary tone). */
  subtitle?: string;
  /** Optional inline element next to the title (e.g. a status/filter chip). */
  adornment?: ReactNode;
}

/**
 * The single, theme-driven page title used by every screen (hybrid-3c.md
 * v3.5). Typography comes from the theme — the `h1` page-title variant plus
 * the tertiary micro-tone for the subtitle — so titles never drift between
 * screens. Never restyle a page title locally; render it through this
 * component instead of an ad-hoc `h5`/`h6`/`CardHeader`.
 */
export function PageTitle({ title, subtitle, adornment }: PageTitleProps) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h1">{title}</Typography>
        {adornment}
      </Box>
      {subtitle && (
        <Typography variant="body2" sx={{ color: (theme) => theme.custom.text.tertiary }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default PageTitle;
